import * as Sentry from '@sentry/react';

function ErrorFallback({ error, resetError }: { error: unknown; componentStack: string; eventId: string; resetError: () => void }) {
  const message = error instanceof Error ? error.message : String(error);
  return (
    <div className="flex min-h-screen items-center justify-center bg-zinc-950 p-4">
      <div className="max-w-md rounded-lg border border-red-500/20 bg-zinc-900 p-6 text-center">
        <h2 className="mb-2 text-lg font-semibold text-red-400">Something went wrong</h2>
        <p className="mb-4 text-sm text-zinc-400">{message}</p>
        <button
          onClick={resetError}
          className="rounded bg-zinc-700 px-4 py-2 text-sm text-zinc-200 hover:bg-zinc-600"
        >
          Try again
        </button>
      </div>
    </div>
  );
}

export const SentryErrorBoundary = Sentry.withErrorBoundary(
  ({ children }: { children: React.ReactNode }) => <>{children}</>,
  { fallback: ErrorFallback },
);
